import React, {useCallback, useEffect, useMemo, useState} from "react";
import {useSelector, useDispatch} from "react-redux";

import Burger from "assets/images/burger.svg";
import Avatar from "assets/images/avatar.svg";

import {
  getToggleSidebar,
  setToggleSidebar,
} from "reduxStore/reducers/toggleSidebar";
import {getAuth} from "../redux/reducers/auth";
import {websocketMessageTypes} from "../components/websocket/WebsocketApi";
import {UseCloseSocketSession} from "../redux/api/DisconnectSocket";
import {Select} from "../components/Select";
import {useGetTenancyListQuery} from "../redux/api/TenancyApi";
import {authConstants} from "../constants/authConstants";
import {domainCookie, getCookie, setCookie} from "../utils/api";
import {Load} from "../components/load/Load";
import LogoutBtn from "../components/LogoutBtn";
import {useLocation} from "react-router-dom";

export default function Users() {
  const dispatch = useDispatch();
  const {isOpen} = useSelector(getToggleSidebar);
  const {right, login, name} = useSelector(getAuth);
  const sessionId = sessionStorage.getItem(websocketMessageTypes.SESSION_ID);
  const [disconnectSocket] = UseCloseSocketSession();
  const {data, isLoading} = useGetTenancyListQuery();
  const currentTenant = getCookie(authConstants.tenant);

  const {pathname} = useLocation();

  const isCurrentPageC_CC_Card = useMemo(() => {
      return (/(^|\/)client(\/|$)/.test(pathname))    },
    [pathname]);

  const [currentTenancy, setCurrentTenancy] = useState(null);
  const options = useMemo(() => ({
    domain: domainCookie
  }), []);

  const changeCurrentTenancy = useCallback((e) => {
    setCurrentTenancy(e);
    setCookie(authConstants.tenant, e.value, options)
    window.location.reload();
  }, []);

  useEffect(() => {
    const currentTenantValue = currentTenant ?
      data?.filter(item => +item.value === +currentTenant)?.[0] :
      data?.[0];
    data && !currentTenant && setCookie(authConstants.tenant, currentTenantValue?.value, options);
    data && setCurrentTenancy(currentTenantValue);
  }, [data]);

  if (isLoading) return <Load/>


  return (
    <header className={`header ${isOpen ? "open" : ""}`}>
      <div className="ml-4 ">
        <button
          className="border-0 bg-white outline-none burger-button"
          onClick={() => {
            dispatch(setToggleSidebar({isOpen: !isOpen}));
          }}
        >
          <img src={Burger} alt="burger-menu"/>
        </button>
      </div>

      {data?.length > 1 && !isCurrentPageC_CC_Card && window.location.host !== "demo.admin.adverton.kz" &&  <div className={"position-relative"} style={{width: "120px"}}>
        {/*{isLoading && <Load/>}*/}
        <Select
          name={"teamIds"}
          defaultValue={currentTenancy}
          options={data || []}
          value={currentTenancy}
          onChange={changeCurrentTenancy}
        />
      </div>}
      <div className={"d-flex align-items-center"}>
        {/*<SwitchLang/>*/}
        <div className={""}>
          <img src={Avatar} alt={"avatar"}/>
        </div>
        <div className={"px-3"}>
          <div className={"font-weight-bold"}>{login}</div>
          <div>{name || right}</div>
        </div>
        <LogoutBtn/>
      </div>

    </header>
  );
}
